module.exports = __webpack_public_path__ + "img/nclogo.3b474b25.png";